import { html, LitElement } from 'lit-element';

/**
 * @element rationale-modal
 * @prop {String} rationale - Response
 */
export class RationaleModal extends LitElement {
  static get properties() {
    return {
      rationale: {
        type: String,
        attribute: false,
      },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`<div>
      <p>
        <strong>Rationale</strong>
        <math-rendering-element
          .label=${this.rationale || 'No rationale available'}
        ></math-rendering-element>
      </p>
    </div>`;
  }
}

export default RationaleModal;
